// extracted by mini-css-extract-plugin
export default {"AlertContainer":"AlertOkStyle_AlertContainer__gZ5Nd","active":"AlertOkStyle_active__S0IXW","button":"AlertOkStyle_button__zf6Us","borderAlert":"AlertOkStyle_borderAlert__rsEqn"};